import { Table, Text } from '@chakra-ui/react'
import { DateTime } from 'luxon'

import { Box } from '@/components/ui/box'
import useColorModeValue from '@/hooks/useColorModeValue'
import { IField, ITNETable } from '@/types/tasksApprovals'

import { TableRow } from './TableRow'

const TNETable = ({ item }: { item: IField }) => {
    const rows = (item.value as ITNETable).rows
    const columns = (item.value as ITNETable).columns
    const rowsLength = rows.length
    const theadColor = useColorModeValue('rgba(84, 79, 64, 0.7)', 'var(--chakra-colors-white)')

    return (
        <Box py="8px" px="24px" whiteSpace="pre-line">
            <Text fontSize={14} pb="4px">
                {item.name}
            </Text>
            <Table.ScrollArea maxH={rowsLength > 5 ? '240px' : 'auto'}>
                <Table.Root stickyHeader>
                    <Table.ColumnGroup>
                        {columns.map((column) => {
                            if (column.field === 'comments' || column.field === 'remark') {
                                return
                            }
                            return <Table.Column key={column.field} />
                        })}
                        <Table.Column htmlWidth={'50px'} />
                    </Table.ColumnGroup>
                    <Table.Header borderLeft="4px solid" borderColor={'transparent'}>
                        <Table.Row backgroundColor={useColorModeValue('white', 'dark.800')}>
                            {columns.map((column, index: number) => {
                                if (column.field === 'comments' || column.field === 'remark') {
                                    return
                                }
                                return (
                                    <Table.ColumnHeader
                                        key={column.field}
                                        textAlign={index === 0 ? 'left' : 'center'}
                                        color={theadColor}
                                        fontSize={'12px'}
                                        textTransform={'uppercase'}
                                    >
                                        {column.header}
                                    </Table.ColumnHeader>
                                )
                            })}
                            <Table.ColumnHeader></Table.ColumnHeader>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {rows.map((row, id) => (
                            <TableRow
                                row={row}
                                columns={columns}
                                columnsLength={columns.length}
                                key={`${id}-${DateTime.now().toMillis()}`}
                            />
                        ))}
                    </Table.Body>
                </Table.Root>
            </Table.ScrollArea>
        </Box>
    )
}

export default TNETable
